import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import customAxios from "../../customAxios";
import { UPDATE_DRIVER } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const updateDriver = async (props: ICreateAndUpdateDriver) => {
  const body = {
    ...props,
  };

  try {
    return (await customAxios.put(UPDATE_DRIVER + `/${props._id}`, body)).data;
  } catch (error: unknown) {
    console.error({ UPDATE_ADMIN: error });
    return false;
  }
};

export default updateDriver;
